export default __webpack_public_path__ + "static/media/348.658444e0.jpg";